import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Input } from '../../../../common/html/input'
import { IGNORE_CHARACTER, MAX_INPUT_LENGTH } from '../constant'
import {
  changeErrors,
  changeSettingOther,
  selectErrors,
  selectOtherSetting,
} from '../store/slice'
import { EditName } from './EditName'

export const ProfileName = ({ createMode, isFollowingList }) => {
  const dispatch = useDispatch()

  const profileAlertsName = useSelector(selectOtherSetting('profileName'))
  const isDefaultProfile = useSelector(selectOtherSetting('isDefault'))
  const error = useSelector(selectErrors('profileAlertsName'))

  const handleChangeName = (value) => {
    dispatch(changeSettingOther({ profileName: value }))
    dispatch(changeErrors({ profileAlertsName: null }))
  }

  const clearError = () => {
    if (error) {
      dispatch(changeErrors({ profileName: null }))
    }
  }

  const onChange = (e) => {
    handleChangeName(
      e.target.value
        .slice(0, MAX_INPUT_LENGTH)
        .split('')
        .filter((c) => !IGNORE_CHARACTER.includes(c))
        .join(''),
    )
    clearError()
  }

  return (
    <div className="flex1">
      {createMode ? (
        <Input
          isShowLabel
          isShowIcon={false}
          placeHolder="alertSetting.PROFILE_NAME"
          value={profileAlertsName || ''}
          onChange={onChange}
          noControl
        />
      ) : (
        <EditName
          originName={profileAlertsName}
          handleChangeName={handleChangeName}
          clearError={clearError}
          disabled={isDefaultProfile}
        />
      )}

      {error && (
        <Element className="fstItalic" style={{ color: '#E0505B' }}>
          <Translate value={error} />
        </Element>
      )}

      {!createMode && isFollowingList && (
        <div className="mt1">
          <Translate value="alertSetting.FOLLOWING_LIST_ALERT_NOTE" />
        </div>
      )}
    </div>
  )
}
